import React from 'react';
import {
  Heading,
  Flex,
  useColorModeValue,
  AspectRatio,
} from '@chakra-ui/react';

function Mapa() {
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      py={16}
      id="mapa"
    >
      <Heading
        color={useColorModeValue('teal.500', 'orange.400')}
        fontWeight="bold"
        textDecor="underline"
        as="h1"
        size="xl"
        my={5}
        textAlign="center"
      >
        Local
      </Heading>
      <AspectRatio ratio={16 / 9} w="90%" display="flex">
        <iframe style={{ position: 'relative', height: 'auto' }} title="mapa" width="425" height="350" framebBrder="0" scrolling="no" marginHeight="0" marginWidth="0" src="https://www.openstreetmap.org/export/embed.html?bbox=-38.574690520763404%2C-3.746246050072184%2C-38.572635948658%2C-3.7447552507305497&amp;layer=mapnik" />
      </AspectRatio>
    </Flex>
  );
}

export default Mapa;
